import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { BlogPostDetail, BlogPostSummary } from '../seo/blog.config';
import { toLang } from '../seo/seo.config';
import { BlogService } from './blog.service';

/** `:lang` sits on the parent route, so walk up rather than trusting the leaf's params. */
function routeLang(route: ActivatedRouteSnapshot): ReturnType<typeof toLang> {
  let node: ActivatedRouteSnapshot | null = route;
  while (node) {
    const value = node.paramMap.get('lang');
    if (value) return toLang(value);
    node = node.parent;
  }
  return toLang(null);
}

/**
 * Resolvers, not in-component fetches, because SeoService needs the article to be there
 * when NavigationEnd fires: title, description, canonical, hreflang and the BlogPosting
 * JSON-LD all come from it, and they have to be in the server-rendered head.
 */
export const blogListResolver: ResolveFn<BlogPostSummary[]> = (
  route,
): Observable<BlogPostSummary[]> => inject(BlogService).list(routeLang(route));

export const blogPostResolver: ResolveFn<BlogPostDetail | null> = (
  route,
): Observable<BlogPostDetail | null> =>
  inject(BlogService).get(routeLang(route), route.paramMap.get('slug') ?? '');
